import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineCheckInBaggagePolicies,
  createAcceptance,
  createBaggage,
  createJourneyElement,
  createJourneyElementCommon,
  createMockData,
  createMockDataWithResponse,
  createName,
  createRegulatoryDetail,
  createRegulatoryDetailsReplyData,
  MockAcceptance,
  MockJourneyElementCommon,
  MockRegulatoryDetailsReplyData,
} from '@dapi/sdk/spec';
import {
  acceptedJourney,
  addedBaggageTemplate,
  defaultBoardingPassResult,
  defaultCheckInBaggagePolicies,
  defaultRegulatoryDetails,
  firstFreeSeat,
  journeys,
  noItemToPayError,
  seatmap,
  secondFreeSeat,
  secondFreeSeatOnJourney,
} from '../../mock/data';
import {
  address,
  contactEmail,
  contactPhone,
  defaultPhoneNumber,
  namedTraveler,
  namedTravelerIdentifier,
  passport,
  personalDetails,
  visa,
} from '../../mock/dictionaries';

const checkedInJourneyElementFirstSeat: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        seat: firstFreeSeat,
        checkInStatus: 'accepted',
        traveler: namedTraveler,
        travelerId: namedTraveler.id
      }
    })
  }
});

const checkedInJourneyElementSecondSeat: MockJourneyElementCommon = createJourneyElementCommon({
  template: {
    journeyElement: createJourneyElement({
      template: {
        seat: secondFreeSeat,
        checkInStatus: 'accepted',
        traveler: namedTraveler,
        travelerId: namedTraveler.id
      }
    })
  }
});

const acceptance: MockAcceptance = createAcceptance({
  template: {
    checkedInJourneyElements: [checkedInJourneyElementFirstSeat],
    isAccepted: true
  }
});

const aRegulatoryDetails: MockRegulatoryDetailsReplyData = createRegulatoryDetailsReplyData({
  template: {
    ...defaultRegulatoryDetails,
    storedDetails: [
      createRegulatoryDetail({
        template: {
          personalDetails: personalDetails
        }
      }),
      createRegulatoryDetail({
        template: {
          document: passport
        }
      }),
      createRegulatoryDetail({
        template: {
          document: visa
        }
      }),
      createRegulatoryDetail({
        template: {
          address: address
        }
      }),
      createRegulatoryDetail({
        template: {
          phoneNumber: {
            ...defaultPhoneNumber,
            name: createName({
              template: {
                lastName: 'SKYWALKER'
              }
            }),
            countryPhoneExtension: '33'
          }
        }
      })
    ]
  }
});

const baggage = createMockData([{
  ...createBaggage({
    template: addedBaggageTemplate,
    id: 0
  }),
  travelerIds: [namedTravelerIdentifier]
}]);
const CONTACTS = [{
  ...contactPhone,
  travelerIds: [namedTraveler.id]
}, {
  ...contactEmail,
  travelerIds: [namedTraveler.id]
}];

/**
 * OW 1Journey
 * 1ADT
 * Test adding 1 Bag
 * Test changing from first free seat to second free seat
 * Test updating regulatory details (contact name / country)
 * Test updating contact details (email / phone)
 */
export const ow1Journey1AdtManageYourBooking: MockMap = {
  addContactsToJourney: [createMockData(CONTACTS)],
  addJourneyBags: [baggage],
  addRegulatoryDetails: [createMockData(aRegulatoryDetails)],
  assignSeatToJourneyElement: [
    createMockDataWithResponse(secondFreeSeatOnJourney[0], 201)
  ],
  generateBoardingPasses: [createMockDataWithResponse(defaultBoardingPassResult, 201)],
  getBaggagePoliciesFromJourney: [
    createMockData(combineCheckInBaggagePolicies([{
      ...defaultCheckInBaggagePolicies,
      travelerIds: [namedTraveler.id]
    }]).items)
  ],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [noItemToPayError])],
  getRegulatoryDetails: [
    createMockData(defaultRegulatoryDetails),
    createMockData(aRegulatoryDetails)
  ],
  removeBaggagesFromJourney: [],
  requestAcceptanceOfJourney: [
    createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(acceptance, 201),
    createMockDataWithResponse(acceptance, 201)
  ],
  retrieveJourneyBaggages: [
    createMockData([{
      ...BaggageRepository.DEFAULT,
      travelerIds: [namedTraveler.id]
    }])
  ],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([acceptedJourney], 201)
  ],
  retrieveJourney: [
    createMockData({
      ...acceptedJourney,
      journeyElements: [checkedInJourneyElementFirstSeat]
    }),
    createMockData({
      ...acceptedJourney,
      journeyElements: [checkedInJourneyElementSecondSeat]
    })
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
